import {IComboboxV2Options} from './v2';
import iconSelectHtml from './icon-select.html?raw';

export let template = iconSelectHtml;

/** Leading addon icon + combobox for call sites that need both. */
export interface IComboboxIconSelectParams<T> {
    icon: string
    comboboxParams: IComboboxV2Options<T>
}

export class viewModel<T> {
    readonly icon: string
    readonly comboboxParams: IComboboxV2Options<T>
    /** Same object passed to {@link component/combobox/v2}. */
    readonly v2Options: IComboboxV2Options<T>

    constructor(params: IComboboxIconSelectParams<T>) {
        this.icon = params.icon
        this.comboboxParams = params.comboboxParams
        this.v2Options = params.comboboxParams
    }
}
